import { setupI18n } from "@lingui/core";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/es";
// import { en, es } from "make-plural/plurals";
import enMessages from "./locales/en/messages.json";
import esMessages from "./locales/es/messages.json";

// Plugin necesario para parsear formatos no-ISO como "MM/DD/YYYY hh:mm A".
dayjs.extend(customParseFormat);

const browserLocale = navigator.language.split("-")[0];
const defaultLocale = ["en", "es"].includes(browserLocale)
  ? browserLocale
  : "en";

// Sincroniza el locale de dayjs con el idioma inicial para que los meses
// (D MMM YYYY) salgan en español cuando el idioma sea 'es'.
dayjs.locale(defaultLocale);

const i18n = setupI18n({
  locales: ["en", "es"],
  locale: defaultLocale,
  messages: {
    en: enMessages,
    es: esMessages,
  },
  //   pluralRules: {
  //     en,
  //     es,
  //   },
});

export default i18n;
